import { breakpoints } from './breakpoints';
import { palette } from './colors';
import { sizes } from './sizes';
import { spacings } from './spacings';
import { typography } from './typography';
import { iconSizes } from './icons';
import { grid } from './grid';
import { borderRadius } from './borders';

export const foundations = {
  grid,
  breakpoints,
  palette,
  ...typography,
  sizes,
  spacings,
  iconSizes,
  borderRadius,
};
